<template>
  <div>
    <section class="section page__content">
      <div class="page__row page__row_between">
        <h2 class="title">
          {{ tableTitle }}
        </h2>

        <PageControlGroup
          v-if="rightsAll"
          :visible-btn-remove="visibleBtnRemove"
          @remove="openConfirmationRemove"
          @add="onCreate"
        />
      </div>

      <slot name="beforeTable" />

      <TableVuex
        :namespaced="namespaced"
        :has-checkbox="rightsAll"
      />
    </section>

    <PaginationVuex :namespaced="namespaced" />

    <BaseModal
      v-if="isVisibleModal"
      @close="closeModal"
      :title="modalTitle"
    >
      <slot
        name="modalForm"
        :isSendingRequest="isSendingRequest"
        :createSubmit="createSubmit"
        :closeModal="closeModal"
      />
    </BaseModal>

    <transition name="fade">
      <AppConfirmation
        v-if="confirmationRemove.active"
        :text="confirmationRemove.text"
        :is-sending="isSendingRequest"
        @confirm="deleteSelected"
        @reject="closeConfirmationRemove"
      />
    </transition>
  </div>
</template>

<script>
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import BaseModal from '@/components/page/modal/base/BaseModal.vue'
import PageControlGroup from '@/components/page/button/PageControlGroup'
import PaginationVuex from '@/components/page/pagination/PaginationVuex'
import TableVuex from '@/components/page/table/TableVuex'

import { MIXIN_MODAL } from '@/mixins/modal/mixinModal'
import { MIXIN_MODAL_CONFIRMATION_REMOVE } from '@/mixins/modal/mixinModalConfirmationRemove'
import { MIXIN_PAGE_TABLE_CONTROL_ACTIONS } from '@/mixins/page/mixinPageTableControlActions'
import { goToPage } from '@/utils/router'

export default {
  // компонент для группы из: заголовка таблицы, создать/удалить, модалки создания/удаления, пагинации.
  // данные должны быть взяты по namespaced из vuex.
  name: 'TableGroup',
  components: {
    AppConfirmation,
    BaseModal,
    PaginationVuex,
    PageControlGroup,
    TableVuex
  },

  mixins: [
    MIXIN_MODAL,
    MIXIN_MODAL_CONFIRMATION_REMOVE,
    MIXIN_PAGE_TABLE_CONTROL_ACTIONS
  ],

  props: {
    namespaced: {
      type: String,
      required: true
    },
    rightsAll: {
      type: Boolean,
      required: true
    },
    tableTitle: {
      type: String,
      required: true
    },
    modalTitle: {
      type: String,
      required: true
    },
    initFilter: {
      type: Object,
      required: false,
      default: () => {}
    },
    addToPostData: {
      type: Object,
      required: false,
      default: () => {}
    },
    postDataHasFiles: {
      type: Boolean,
      required: false,
      default: false
    },

    // для загрузки необходимых справочников из vuex при маунте компонента
    namespacedHandbook: {
      type: String,
      required: false,
      default: ''
    },

    // массив с именами справочников для запроса при маунте компонента
    // имя справочника с заглавной буквы
    handbooks: {
      type: Array,
      required: false,
      default: () => []
    },

    // для указания страницы, если создание не через модалку
    routeNameCreate: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    // vuex getters
    visibleBtnRemove () {
      return this.$store.getters[this.namespaced + '/visibleButtonRemoveItems']
    }
  },

  async mounted () {
    await Promise.all([
      this.loadFilter(this.initFilter),
      this.handbooks.map(name => this.$store.dispatch(`${this.namespacedHandbook}/GET${name}List`))
    ])
  },
  destroyed () {
    this.RESET_STORE()
  },

  methods: {
    // vuex mutations
    setFilter (filter) {
      this.$store.commit(this.namespaced + '/SET_FILTER_QUERY', filter)
    },
    RESET_STORE () {
      this.$store.commit(this.namespaced + '/RESET_STORE')
    },

    // vuex actions
    async loadList () {
      return this.$store.dispatch(this.namespaced + '/loadList')
    },

    async loadFilter (filter) {
      return this.$store.dispatch(this.namespaced + '/loadFilter', filter)
    },

    async createItem (data) {
      return this.$store.dispatch(this.namespaced + '/createItem', data)
    },

    async createItemAndPostFiles (data) {
      return this.$store.dispatch(this.namespaced + '/createItemAndPostFiles', data)
    },

    async deleteItems () {
      return this.$store.dispatch(this.namespaced + '/deleteItems')
    },

    async POSTFileList (formDataFileList) {
      return this.$store.dispatch(this.namespaced + '/POSTFileList', formDataFileList)
    },

    onCreate () {
      if (this.routeNameCreate) {
        return goToPage(this.routeNameCreate)
      }

      this.openModal()
    },
    // если создание через модалку
    async createSubmit (data) {
      await this.sendPostRequest(async () => {
        const preparedData = {
          ...data,
          ...this.addToPostData
        }

        this.postDataHasFiles ? await this.createItemAndPostFiles(preparedData) : await this.createItem(preparedData)

        await this.loadList()
      })
    }
  }
}
</script>
